module.exports = __webpack_public_path__ + "spa_static_mobile/img/complaint.f169515d.png";